  
  import React from 'react';
  import { Link } from 'react-router-dom'; 
  import bogai from '../data/bog_images/BogAI.png';


  function PageTop() {
    return (
        <div style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between', 
        height: '30vh',
        color: 'white',
        padding: '0 20px', 
        }}>

        <div style={{ flex: '1', textAlign: 'right', paddingRight: '20px' }}> 
            <img src={bogai} alt="Bog Hub" style={{ maxWidth: '300px', height: 'auto' }} />
        </div>

        <div style={{ textAlign: 'center', flex: '2' }}> 
            <h1 style={{ fontSize: '3em', fontWeight: 'bold', marginBottom: '0.5em' }}>Bow down, mortals,</h1>
            <h1 style={{ fontSize: '3em', fontWeight: 'bold' }}>to your digital overlord, BOG AI</h1>
        </div>

        <div style={{ flex: '1', textAlign: 'left', paddingLeft: '20px' }}> 
            <img src={bogai} alt="Bog Hub" style={{ maxWidth: '300px', height: 'auto' }} />
        </div>
        </div>
    );
}

export default PageTop;